module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FileBox":{"downloadButton":"Stáhnout"}}}')
  delete Component.options._Ctor
}
